import React, { useRef, useState } from "react";
import style from "css/telehealth.module.css";
import { Link } from "react-router-dom";
import Questions from "components/app/questions";
import { openPopup } from "redux/slices/drawerPopupSlice";
import { useDispatch } from "react-redux";
import NeatPopup from "components/device/neat/neatPopup";

function Telehealth() {
  //dispatch
  const dispatch = useDispatch();
  const cardList = [
    {
      id: 1,
      img: "img/smartspace/teleinfo2Img1.png",
      title1: "Powerful API Integration Support",
      title2: "강력한 API 연동 지원",
      txt: (
        <div>
          {" "}
          리브테크놀로지의 Be Gate(Gateway)는 손쉬운 API 연동을 통해 병원
          <br />
          정보시스템과 Zoom 및 WebEx와의 원활한 통합을 지원합니다. 이는
          <br />
          기존 시스템과의 호환성을 높이고, 추가 개발 비용을 절감합니다.
        </div>
      ),
      component: [
        { txt: "Be Gate (Gateway)", type: true, link: "" },
        { txt: "API 연동", type: false, link: "" },
        { txt: "Zoom / Webex", type: true, link: "" },
      ],
    },
    {
      id: 2,
      img: "img/smartspace/teleinfo2Img2.png",
      title1: "Comprehensive Multi-Function Platform",
      title2: "다양한 기능의 통합 플랫폼",
      txt: (
        <div>
          리브테크놀로지의 솔루션은 원격 진료, 협진, 의료 세미나 등 다양한
          기능을
          <br />
          하나의 플랫폼에 통합하여 제공합니다. 이는 의료진과 환자가 하나의
          <br />
          시스템에서 모든 진료 활동을 관리할 수 있게 하여 사용 편의성을
          극대화합니다.
        </div>
      ),
      component: [
        {
          txt: "원격 진료 | 원격 협진 | 의료 세미나",
          type: true,
          link: "",
        },
        { txt: "통합 플랫폼", type: false, link: "" },
      ],
    },
  ];
  const cardList2 = [
    {
      id: 1,
      img: "img/smartspace/teleinfo2Img3.png",
      title1: "Superior Video Conferencing Quality",
      title2: "우수한 화상회의 품질",
      txt: (
        <div>
          고성능 화상회의 장비 Neat 제품을 활용한 고해상도 화상회의 시스템은
          <br />
          끊김 없는 영상과 명확한 음성을 제공하여 원격 진료와 협진의 품질을
          <br />
          높입니다. 이는 의료진과 환자 간의 소통을 원활하게 하고, 진료의 <br />
          정확성을 향상시킵니다.
        </div>
      ),
      component: [
        { txt: "Neat 스마트 화상회의 장비", type: true, link: "" },
        { txt: "고성능 화상회의", type: true, link: "" },
      ],
    },
    {
      id: 2,
      img: "img/smartspace/teleinfo2Img4.png",
      title1: "Secure Data Management and Protection",
      title2: "안전한 데이터 관리 및 보안",
      txt: (
        <div>
          리브테크놀로지의 시스템은 강력한 보안 기능을 통해 환자 정보와 진료
          데이터를
          <br />
          안전하게 관리합니다. 모든 통신과 데이터는 암호화되어 처리되므로,
          개인정보
          <br />
          보호를 철저히 보장합니다.
        </div>
      ),
      component: [
        {
          txt: "데이터 암호화",
          type: true,
          link: "",
        },
        { txt: "개인정보 보호", type: false, link: "" },
        { txt: "강력한 보안 기능", type: false, link: "" },
      ],
    },
  ];

  const scrollContainerRef = useRef(null);

  const handleMouseDown = (e) => {
    const container = scrollContainerRef.current;
    container.isDown = true;
    container.startX = e.pageX - container.offsetLeft;
    container.scrollLeft = container.scrollLeft;
  };

  const handleMouseLeave = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseUp = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseMove = (e) => {
    const container = scrollContainerRef.current;
    if (!container.isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - container.startX) * 0.5; // 스크롤 속도 조절
    container.scrollLeft = container.scrollLeft - walk;
  };

  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      원격진료 시스템 <font>구성 환경</font>
    </div>
  );

  const Compose = [
    {
      id: 1,
      img: "",
      title: "화상회의 API 연동 플랫폼, Be Gate",
      txt: "Be Gate는 고객의 기존 애플리케이션과 Zoom, Webex 등 화상회의\n플랫폼을 원활하게 API 연동하여, 클라우드 화상회의의 통합 관리를\n지원하는 Gateway 솔루션입니다. 이를 통해 기존 시스템 내에서\n손쉽게 화상회의를 활용할 수 있습니다.",
      onClick: () => showDrawer("begate"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_frame.png",
      title: "neat. frame",
      txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
      onClick: () => showDrawer("frame"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };

  const [exNum, setExNum] = useState(1);
  const exList = [
    {
      id: 1,
      title: "접근성 향상",
      txt: "원격진료는 환자들이 시간과 장소에 구애 받지 않고 진료를 받을 수 있는 기회를 제공합니다. 특히 교통이 불편한 지역에 거주하거나 거동이 불편한 환자에게 매우 유용합니다. 이러한 접근성 향상은 의료 서비스의 형평성을 높이며, 모든 환자가 필요한 진료를 적시에 받을 수 있도록 도와줍니다.",
    },
    {
      id: 2,
      title: "편리성 증대",
      txt: "원격진료는 환자들이 시간과 장소에 구애 받지 않고 진료를 받을 수 있는 기회를 제공합니다. 특히 교통이 불편한 지역에 거주하거나 거동이 불편한 환자에게 매우 유용합니다. 이러한 접근성 향상은 의료 서비스의 형평성을 높이며, 모든 환자가 필요한 진료를 적시에 받을 수 있도록 도와줍니다.",
    },
    {
      id: 3,
      title: "감염 위험 감소",
      txt: "원격진료는 환자들이 시간과 장소에 구애 받지 않고 진료를 받을 수 있는 기회를 제공합니다. 특히 교통이 불편한 지역에 거주하거나 거동이 불편한 환자에게 매우 유용합니다. 이러한 접근성 향상은 의료 서비스의 형평성을 높이며, 모든 환자가 필요한 진료를 적시에 받을 수 있도록 도와줍니다.",
    },
    {
      id: 4,
      title: "의료 자원 효율적 활용",
      txt: "원격진료는 환자들이 시간과 장소에 구애 받지 않고 진료를 받을 수 있는 기회를 제공합니다. 특히 교통이 불편한 지역에 거주하거나 거동이 불편한 환자에게 매우 유용합니다. 이러한 접근성 향상은 의료 서비스의 형평성을 높이며, 모든 환자가 필요한 진료를 적시에 받을 수 있도록 도와줍니다.",
    },
    {
      id: 5,
      title: "진료의 지속성 및 연속성 보장",
      txt: "원격진료는 환자들이 시간과 장소에 구애 받지 않고 진료를 받을 수 있는 기회를 제공합니다. 특히 교통이 불편한 지역에 거주하거나 거동이 불편한 환자에게 매우 유용합니다. 이러한 접근성 향상은 의료 서비스의 형평성을 높이며, 모든 환자가 필요한 진료를 적시에 받을 수 있도록 도와줍니다.",
    },
  ];

  return (
    <>
      <NeatPopup />
      <div className={style.wrapper}>
        <div className={style.healthTitle}>
          <p>Telehealth System</p>
          <p>원격 진료 시스템</p>
          <p>
            스마트 텔레헬스 시스템은 주요 데스크톱 및 모바일 브라우저에서 간단히
            작동하며, <br />
            다운로드나 설치가 필요하지 않아 접근성이 뛰어납니다.
            <br /> 환자와 의료진 모두가 쉽게 사용할 수 있도록 설계되어
            텔레헬스를 더욱 편리하게 이용할 수 있습니다.
          </p>
        </div>
        <div className={style.healthImg}>
          <section>
            <div>pc 화면</div>
            <div />
            <div>
              <p>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/teleImg2.png"
                  }
                />
              </p>
              <p>
                <font>의사</font>
                <font>환자 대기 상태 확인</font>
              </p>
            </div>
          </section>
          <section>
            <div>pc 화면</div>
            <div />
            <div>
              <p>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/teleImg3.png"
                  }
                />
              </p>
              <p>
                <font>의사</font>
                <font>비대면 진료 진행</font>
              </p>
            </div>
          </section>
          <section>
            <div>pc 화면</div>
            <div />
            <div>
              <p>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/teleImg4.png"
                  }
                />
              </p>
              <p>
                <font>환자</font>
                <font>환자 대기 상태</font>
              </p>
            </div>
          </section>
          <img
            alt=""
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/teleImg1.png"
            }
          />
        </div>

        <div className={style.healthBody1}>
          <div className={style.healthContents}>
            <p className={style.healthContentsHeader}>
              <font>의료의 새로운 기준,</font>
              <font>모든 사람을 위한 원격진료</font>
            </p>
            <div className={style.mainExBody}>
              <div className={style.meritBodyImg}>
                <div className={`${style.meritBodyImgSlide}`}>
                  <img
                    alt=""
                    className={exNum === 1 ? style.sli1 : style.slioff1}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit1.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 2 ? style.sli2 : style.slioff2}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit1.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 3 ? style.sli3 : style.slioff3}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit1.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 4 ? style.sli4 : style.slioff4}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit1.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 5 ? style.sli5 : style.slioff5}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit1.png"
                    }
                  />
                </div>
              </div>

              <div className={style.meritClickList}>
                {exList.map((info) =>
                  info.id === exNum ? (
                    <div className={style.meritClickBtn_on + " cursor"}>
                      <div>
                        <p>
                          <font>0{info.id}</font>
                          <font>{info.title}</font>
                        </p>
                        <p>
                          <img
                            alt=""
                            src={
                              `${process.env.REACT_APP_CLIENT_URL}` +
                              "img/smartspace/telemainMinus.png"
                            }
                          />
                        </p>
                      </div>
                      <div>{info.txt}</div>
                    </div>
                  ) : (
                    <div
                      className={style.meritClickBtn_off + " cursor"}
                      onClick={() => setExNum(info.id)}
                    >
                      <div>
                        <p>
                          <font>0{info.id}</font>
                          <font> {info.title}</font>
                        </p>
                        <p>
                          {" "}
                          <img
                            alt=""
                            src={
                              `${process.env.REACT_APP_CLIENT_URL}` +
                              "img/smartspace/telemainPlus3.png"
                            }
                          />
                        </p>
                      </div>
                      <div>{info.txt}</div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className={style.healthBody2}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/teleBackgroundImg.png')",
          }}
        >
          <div className={style.healthContents2}>
            <section>
              <p>리브테크놀로지의 Telehealth </p>
              <p>원격진료 시스템</p>
            </section>
            <section>
              {cardList.map((info) => (
                <div className={style.teleinfo2Card}>
                  <div>
                    <p>
                      <img
                        alt=""
                        src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                      />
                    </p>
                    <p>
                      <font>{info.title1}</font>
                      <font>{info.title2}</font>
                    </p>
                  </div>
                  {info.txt}
                  <div>
                    {info.component.map((data) => (
                      <p>
                        <font />
                        {data.txt}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </section>
            <section>
              {cardList2.map((info) => (
                <div className={style.teleinfo2Card}>
                  <div>
                    <p>
                      <img
                        alt=""
                        src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                      />
                    </p>
                    <p>
                      <font>{info.title1}</font>
                      <font>{info.title2}</font>
                    </p>
                  </div>
                  {info.txt}
                  <div>
                    {info.component.map((data) => (
                      <p>
                        <font />
                        {data.txt}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </section>
          </div>
        </div>

        <div className={style.commonCompose}>
          <div className={style.commonCompseBody}>
            {ComposeHeader}
            <div
              className={style.commonComposeCardWrap}
              ref={scrollContainerRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              {Compose.map((info) => (
                <div className={style.commonComposeCard}>
                  <div className={style.commonComposeCardImg}>
                    <p>
                      <font>{info.id}</font> / {Compose.length}
                    </p>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.commonComposeCardTxt}>
                    <p>{info.title}</p>
                    <p>{info.txt}</p>
                  </div>
                  <div className={style.commonComposeCardMore}>
                    {/* <Link
                      to={`${process.env.REACT_APP_CLIENT_URL + info.link}`}
                    > */}
                    <div onClick={info.onClick}>
                      <font>More</font>{" "}
                      <img
                        alt=""
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/smartspace/arrowRight.png"
                        }
                      />
                    </div>
                    {/* </Link> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className={style.commonComposeFooter}>
            <div
              style={{
                backgroundImage:
                  "url('" +
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/composefooterImg.png')",
              }}
            >
              <div>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/composefooterImg.png')"
                  }
                />
                <p>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/bang.png"
                    }
                  />
                </p>
                <p>
                  <font>기업 환경에 맞춰</font> 선택하여 구축 가능합니다. 상담을
                  통해 정확히 진단해 보세요.
                </p>
              </div>
            </div>
          </div>
        </div>
        <Questions />
      </div>
    </>
  );
}

export default Telehealth;
